<template>
  <div v-if="$mq == 'sm' || $mq == 'xs'">
    <div id="taCardCarousel" class="carousel slide w-100" data-ride="carousel" data-interval="2000">
      <div class="carousel-inner carousel-inner-breakescape w-100" role="listbox">
        <div class="carousel-item active">
          <div class="card text-white bg-secondary">
            <img src="/img/logo/ta-tc2024.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2024">
            <div class="card-body">
              <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2024</h5>
            </div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="card text-white bg-secondary">
            <img src="/img/logo/ta-tc2023.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2023">
            <div class="card-body">
              <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2023</h5>
            </div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="card text-white bg-secondary">
            <img src="/img/logo/ta-tc2022HQ.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2022">
            <div class="card-body">
              <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2022</h5>
            </div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="card text-white bg-secondary">
            <img src="/img/breakescape/page-01_trip21.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2021">
            <div class="card-body">
              <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2021</h5>
            </div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="card text-white bg-secondary">
            <img src="/img/breakescape/page-01_trip20.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2020">
            <div class="card-body">
              <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2020</h5>
            </div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="card text-white bg-secondary">
            <img src="/img/breakescape/page-01_trip19.png" class="card-img-top" alt="Trip Advisor CoE 2019">
            <div class="card-body">
              <h5 class="card-title text-white">Trip Advisor Certificate of Excellence 2019</h5>
            </div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="card text-white bg-secondary">
            <img src="/img/breakescape/page-01_trip18.png" class="card-img-top" alt="Trip Advisor CoE 2018">
            <div class="card-body">
              <h5 class="card-title text-white">Trip Advisor Certificate of Excellence 2018</h5>
            </div>
          </div>
        </div>
      </div>
      <a class="carousel-control-prev" href="#taCardCarousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#taCardCarousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
  <div v-else>
    <div class="card-deck">
      <div class="card text-white bg-secondary">
        <img src="/img/logo/ta-tc2024.png" class="bg-white card-img-top" alt="Trip Advisor Travellers' Choice 2024">
        <div class="card-body">
          <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2024</h5>
        </div>
      </div>

      <div class="card text-white bg-secondary">
        <img src="/img/logo/ta-tc2023.png" class="bg-white card-img-top" alt="Trip Advisor Travellers' Choice 2023">
        <div class="card-body">
          <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2023</h5>
        </div>
      </div>

      <div class="card text-white bg-secondary">
        <img src="/img/logo/ta-tc2022HQ.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2022">
        <div class="card-body">
          <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2022</h5>
        </div>
      </div>

      <div class="card text-white bg-secondary">
        <img src="/img/breakescape/page-01_trip21.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2021">
        <div class="card-body">
          <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2021</h5>
        </div>
      </div>

      <div class="card text-white bg-secondary">
        <img src="/img/breakescape/page-01_trip20.png" class="card-img-top" alt="Trip Advisor Travellers' Choice 2020">
        <div class="card-body">
          <h5 class="card-title text-white">Trip Advisor Travellers' Choice 2020</h5>
        </div>
      </div>

      <div class="card text-white bg-secondary">
        <img src="/img/breakescape/page-01_trip19.png" class="card-img-top" alt="Trip Advisor CoE 2019">
        <div class="card-body">
          <h5 class="card-title text-white">Trip Advisor Certificate of Excellence 2019</h5>
        </div>
      </div>

      <div class="card text-white bg-secondary">
        <img src="/img/breakescape/page-01_trip18.png" class="card-img-top" alt="Trip Advisor CoE 2018">
        <div class="card-body">
          <h5 class="card-title text-white">Trip Advisor Certificate of Excellence 2018</h5>
        </div>
      </div>
    </div>
  </div>
  <!-- style="overflow-x: scroll; -->
</template>

<script>
export default {
  props: {

  },

  data() {
    return {

    };
  },

  computed: {

  },

  methods: {

  },
}
</script>
